import React from 'react';
import { DateTimePicker } from '@mui/x-date-pickers';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { RootState } from '../../../state/store/store';
import { localizationSelectors } from '../../../state/ducks/localization/selectors';
import moment, { Moment } from 'moment';

type Props = {
    onChange: (date: Moment | null) => void;
    value: Moment;
    localization: any;
};

const StaticDateTimePicker = (props: Props) => {
    return (
        <DateTimePicker
            value={props.value}
            onChange={props.onChange}
        />
    );
};
const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: none;
    font-size: 15px;
`;
const StyledIcon = styled.span`
    margin-right: 5px;
    font-size: 22px;
`;
const mapStateToProps = (state: RootState) => ({
    localization: localizationSelectors.common(state)
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StaticDateTimePicker);
